import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';

import { Autoplay, Pagination } from 'swiper/modules';
import BannerSliderPng from '../../assets/BannerSlider.png';
import BannerSliderPng2 from '../../assets/BannerSliderPng2.jpg';
import DownButton from '../../assets/DownButton.svg';
import LogoCube from '../../assets/LogoCube.png';
import LogoTransparent from '../../assets/LogoTransparent.png';
import style from './SliderBanner.module.scss';

export default function SliderBanner({nextBlockRef}) {

    const scrollToNextBlock = () => {
        nextBlockRef.current.scrollIntoView({ behavior: 'smooth' });
    };
    return (
        <div style={{position:'relative'}}>
            <Swiper
                direction={'vertical'}
                spaceBetween={30}
                autoplay={{
                    delay: 3500,
                    disableOnInteraction: false,
                }}
                loop={true}
                pagination={{
                    clickable: true,
                }}
                modules={[Autoplay, Pagination]}
                className="mySwiper"
                allowTouchMove={false}

            >
                <SwiperSlide>
                    <img className={style.banner} src={BannerSliderPng} alt=""/>
                    <img className={style.logoCube} src={LogoCube} alt=""/>
                    <img className={style.logoTransparent} src={LogoTransparent} alt=""/>
                </SwiperSlide>
                <SwiperSlide>
                    <img className={style.banner2} src={BannerSliderPng2} alt=""/>
                    <div className={style.bannerBlur}></div>
                    <div className={style.textBanner} style={{width: '400px'}}>будьте на шаг впереди</div>
                    <img className={style.logoTransparent} src={LogoTransparent} alt=""/>
                </SwiperSlide>
                <SwiperSlide>
                    <img className={style.banner} src={BannerSliderPng} alt=""/>
                    <div className={style.textBanner}>выбирайте консультанта, понимающего ваш бизнес</div>
                    <img className={style.logoTransparent} src={LogoTransparent} alt=""/>
                </SwiperSlide>
            </Swiper>
            <div className={style.blur}></div>
            <div onClick={scrollToNextBlock} className={style.buttonDowm}>
                <img src={DownButton} alt="DownButton"/>
            </div>
        </div>
    );
}
